<template>
  <div class="row">
    <div class="col col-12">
      <form>
        <div
          v-for="(parameter, key) in this.parametersTypes"
          :key="'parameterType-' + key"
        >
          <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{
              parameter.type_name
            }}</label>
            <div class="col-sm-7">
              <parameter
                :ref="'parameter-' + parameter.id"
                :name="getParameterKey(parameter.type_name)"
                :parameter="filterData(parameter.id)"
                :parameterList="filterParameterList(parameter.id)"
              >
              </parameter>
            </div>
            <div class="col-sm-2 my-auto">
              <div v-show="checkSync()" class="tooltip">
                <i
                  class="fa"
                  :class="{
                    'fa-check text-success': checkSyncParameter(parameter),
                    'fa-warning text-danger': !checkSyncParameter(parameter),
                  }"
                ></i>
                <span class="tooltiptext">{{
                  textParameterTooltip(parameter)
                  }}</span>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>

</style>
<script>
import Parameter from './Forms/Parameter.vue'

export default {
  name: 'VNFRProductParameters',
  props: {
    parameters: {
      type: Array,
      required: true
    },
    loadingData: {
      type: Boolean,
      required: false
    },
    parametersTypes: {
      type: Array,
      required: false
    },
    parametersList: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      parametersTypeConfig: []
    }
  },
  watch: {
    'loadingData'( newValue ) {
      if ( newValue === true ){
        this.$emit( 'loading', true )
      } else {
        this.$emit( 'loading', false )
      }
    }
  },
  methods: {
    getDefaultParameter( paramTypeId ) {
      return {
        id: null,
        parameter_type_id: paramTypeId,
        value: ''
      }
    },
    checkSync(){
      return this.$parent.$parent.checkSync()
    },
    checkSyncParameter( parameter ) {
      return this.$parent.$parent.checkSyncElement( `parameter_${  parameter.id}` )
    },
    textParameterTooltip( parameter ){
     return this.$parent.$parent.textSyncElement( `parameter_${  parameter.id}` )
    },
    filterData( parameterTypeId ) {
      const data = this.parameters.filter(
        param => param.parameter_type_id === parameterTypeId
      )
      if ( data.length > 0 ) {
        return data[ 0 ]
      } else {
        const defaultParameter = this.getDefaultParameter( parameterTypeId )
        defaultParameter.parameter_type_id = parameterTypeId
        this.parameters.push( defaultParameter )
        return this.filterData( parameterTypeId )
      }
    },
    filterParameterList( parameterTypeId ) {
      return this.parametersList.filter(
        parameter => parameter.parameter_type_id === parameterTypeId
      )
    },
    getParameterKey( name ) {
      return name.replace( /\s+/g, '_' ).toLowerCase()
    },
    validationForms() {
      const promiseList = []
      this.parametersTypes.forEach( parameter => {
        promiseList.push( this.validForm( `parameter-${parameter.id}` ) )
      } )
      return Promise.all( promiseList ).then( value => {
          if ( value.includes( false ) ){
            return false
          } else {
            return true
          }
        } )
    },
    validForm( formName ) {
     return this.$refs.[ formName ][ 0 ].$validator.validateAll().then( result => result )
    }
  },
  components: {
    Parameter
  }
}
</script>
